export type SWTypographyVariant = 'large' | 'medium';

export enum InteractiveColor {
  Normal = '#7485A2',
  Warning = '#E16F00',
  Error = '#A03434',
}
